(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-product-bundle-link]');
    if (!link) return;
    const root = link.closest('[data-product-root]');
    if (!root) return;
    const url = new URL(link.href);
    const variant = root.querySelector('[data-variant-select]');
    const sizeOptions = root.querySelector('[data-size-option]');
    const sizeChosen = !sizeOptions || sizeOptions.querySelector('input:checked');
    if (sizeChosen && variant?.value) url.searchParams.set('bundle_variant', variant.value);
    else url.searchParams.delete('bundle_variant');
    link.href = url.href;
  });
})();
